module.exports = __webpack_public_path__ + "static/img/side_logo_max_xybg.24e56581.png";